import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Remove any existing editors to avoid duplicates
    if (window.tinymce) {
      tinymce.remove();
      tinymce.init({
        selector: '.tinymce',
        plugins: [
          'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount'
        ],
        toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | emoticons charmap ',
        tinycomments_mode: 'embedded',
        tinycomments_author: 'Author name',
        link_assume_external_targets: true
      });
    }

    // MutationObserver to remove the TinyMCE promo
    const observer = new MutationObserver(() => {
      document.querySelectorAll('.tox-promotion').forEach(node => node.remove());
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  disconnect() {
    if (window.tinymce) {
      tinymce.remove();
    }
  }
}